export default "__VITE_ASSET__B2RJL38D__"